import { NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { MapView } from "../../../../../constant/VectorTileLayerType";

const InrixViewOptions = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDataCutterActive = location.pathname === "/";
  const isInrixVolumeActive =
    location.pathname === `/view/${MapView.INRIX_VOLUME}`;
  const isInrixAverageSpeedActive =
    location.pathname === `/view/${MapView.INRIX_AVERAGE_SPEED}`;

  return (
    <>
      <NavDropdown.Item
        active={isDataCutterActive}
        onClick={() => navigate("/")}
      >
        DataCutter
      </NavDropdown.Item>
      <NavDropdown.Item
        active={isInrixVolumeActive}
        onClick={() => navigate(`/view/${MapView.INRIX_VOLUME}`)}
      >
        Volume
      </NavDropdown.Item>
      <NavDropdown.Item
        active={isInrixAverageSpeedActive}
        onClick={() => navigate(`/view/${MapView.INRIX_AVERAGE_SPEED}`)}
      >
        Speed Profiles
      </NavDropdown.Item>
    </>
  );
};

export default InrixViewOptions;
